import { FrontPageLink } from "../models/FrontpageLink";
import { GET_FRONTPAGE_LINKS } from "../actions/Action_Home";

interface IHomeState { 
    frontPageLinks: FrontPageLink[];
}

const defaultState: IHomeState = {
    frontPageLinks: []
  };

export default function (state = defaultState, action) {
    switch (action.type) {
        case GET_FRONTPAGE_LINKS:
            const frontPageLinks = action.payload.data as FrontPageLink[];
            return {...state, frontPageLinks: frontPageLinks}
        default:
            return state;
    }
}